import styled from "styled-components"
// import { media } from "utils/utils"
import theme from "styles/theme-main"

export const Wrapper = styled.div`
  position: fixed;
  z-index: 999;
  top: 60px;
  left: 0px;
  width: 100vw;
  background-color: ${theme.colors.danger};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 47px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ButtonContainer = styled.div`
  width: 200px;
  display: flex;
  justify-content: end;
  align-items: center;
  height: 50px;
  margin-right: 10px;
`

export const TitleContainer = styled.div`
  color: white;
  text-transform: uppercase;
  width: auto;
  display: flex;
  justify-content: end;
  align-items: center;
  height: 50px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 2.6px;
`
